export default () => {
  return {
    title: `Check your email for the verification code. It may be in your spam folder.`,
    label: 'Verification Code',
    button: 'Verify',
  };
};
